module.exports = __webpack_public_path__ + "img/orbit.6b678e8a.png";